import React from 'react';
import styled from 'styled-components';

// Grafik ipucu (dataviz): başlık + satırlar — değer ÖNDE ve kalın, seri adı ikincil; renk yalnız yanındaki işarette
// (metin seri renginde yazılmaz). İpucu hiçbir değeri tek başına taşımaz: aynı değerler tablo görünümünde / şeritte.
const Box = styled.div`
  background: #fff;
  border: 1px solid #E5EAF0;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 66, 66, 0.14);
  padding: 8px 10px;
  min-width: 150px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Title = styled.div`
  font-weight: 700;
  margin-bottom: 2px;
`;

const Subtitle = styled.div`
  color: #6B7280;
  font-size: 11px;
  margin-bottom: 4px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
`;

const Key = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: ${({ $kind }) => ($kind === 'box' ? '10px' : '12px')};
  height: ${({ $kind }) => ($kind === 'box' ? '10px' : '2px')};
  border-radius: ${({ $kind }) => ($kind === 'box' ? '2px' : '1px')};
  background: ${({ $color }) => $color};
`;

const Value = styled.span`
  font-weight: 700;
`;

const Label = styled.span`
  color: #6B7280;
`;

const Foot = styled.div`
  margin-top: 4px;
  font-size: 11px;
  color: #6B7280;
`;

export default function ChartTooltip({ title, subtitle, rows = [], footnote }) {
  return (
    <Box>
      {title ? <Title>{title}</Title> : null}
      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      {rows.map((row) => (
        <Row key={row.key}>
          <Key $color={row.color} $kind={row.kind} />
          <Value>{row.value}</Value>
          <Label>{row.label}</Label>
        </Row>
      ))}
      {footnote ? <Foot>{footnote}</Foot> : null}
    </Box>
  );
}
